var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'dk-popper-item': true,
        'dk-popper-item--selectable': _vm.isSelectable,
        'dk-popper-item--selected': _vm.selected && _vm.isParentDkPopper,
    }},[_c('a',{staticClass:"dk-popper-item__link",attrs:{"href":_vm.href},on:{"click":_vm.handleClick}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }